import { render, staticRenderFns } from "./SecondaryBottom.vue?vue&type=template&id=d1ebf660&scoped=true"
import script from "./SecondaryBottom.vue?vue&type=script&lang=js"
export * from "./SecondaryBottom.vue?vue&type=script&lang=js"
import style0 from "./SecondaryBottom.vue?vue&type=style&index=0&id=d1ebf660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ebf660",
  null
  
)

export default component.exports